export default "https://widget.myclimate.org/assets/images/quiz/Grafik_Computer_Frage_2.svg";